import { formatDate, unformatPrice } from "../../../utils";
import {
  calculaSubtotalParaChave,
  calculoDesconto,
  dataEmissaoBloqueada,
  totalItensLista,
  totalPagamentos,
  totalVenda,
} from "../add-nf-saida/add-nf-saida";
import {
  NfSaidaPagamento,
  NfSaidaEnderecoCliente,
  nfSaidaTotalTributos,
  OperacaoFiscal,
  NfSaidaItem,
} from "./index";
import { value as valueHelper } from "../../../helpers";
import { isBefore } from "date-fns";

export class NfSaida {
  updatedAt = null;
  createdAt = null;
  insertUserId = null;
  status = null;
  pedidoIds = null;
  orcamentoIds = null;
  ordemServicoIds = null;
  condicionalIds = null;
  serieDocumento = null;
  dataEmissao = null;
  operacaoFiscalId = null;
  grupoTributarios = null;
  modeloDocumento = null;
  notasCredito = null;
  operacaoFiscal = null;
  chaveAcesso = null;
  quantidadeParcelas = null;
  chaveAcessoReferencia = null;
  clienteId = null;
  clienteEmail = null;
  clienteNome = null;
  clienteCnpjCpf = null;
  clienteInscricaoEstadual = null;
  clienteInscricaoSuframa = null;
  vendedorId = null;
  prestadorServicoId = null;
  modalidadeFrete = null;
  freteCompoeNota = null;
  desconto = null;
  frete = null;
  descontoPorcentagem = null;
  acrescimo = null;
  despesas = null;
  totalVenda = 0;
  totalMercadoria = 0;
  totalPagamentos = 0;
  informacoesOperacaoFiscal = null;
  informacoesAdicionais = null;
  informacoesFisco = null;
  intermediadorRazaoSocial = null;
  intermediadorCnpj = null;
  nfSaidaEnderecoCliente = null;
  documentoDevolucaoCliente = null;
  documentoDevolucaoFornecedor = null;
  transportadoraId = null;
  transportadoraNome = null;
  transportadoraCnpjCpf = null;
  transportadoraIe = null;
  transportadoraEnderecoRua = null;
  transportadoraEnderecoMunicipio = null;
  transportadoraEnderecoUf = null;
  transportadoraExportacaoUf = null;
  transportadoraExportacaoLocalEmbarque = null;
  transportadoraExportacaoLocalDesembarque = null;
  qtdVolumes = null;
  pesoBruto = null;
  pesoLiquido = null;
  produtoMarca = null;
  produtoNumero = null;
  especieVolume = null;
  nfSaidaItens = [];
  nfSaidaPagamentos = [];
  devolucoesClienteIds = null;
  devolucoesFornecedorIds = null;
  nfSaidaImportadaId = null;
  orcamentoImport = null;
  pedidoImport = null;
  ordemServicoImport = null;
  importacaoDocumento = null;
  vendedorObrigatorio = null;
  enderecoEntregaId = null;
  vendedorBancoCaixaId = null;
  meioPagamentoId = null;
  condicaoPagamentoId = null;
  operacaoEntrada = null;
  numeroProtoc = null;
  descontoItem = null;
  freteItem = null;
  despesasItem = null;
  empresaDestinoId = null;
  subtotalTributosIncidentes = null;
  baseIcmsTotal = null;
  valorIcmsTotal = null;
  baseIcmsSt = null;
  valorIcmsSt = null;
  valorIpiTotal = null;
  valorIbsUf = null;
  valorIbsMun = null;
  valorCbsTotal = null;
  obrigatoriedadeMeioPagamento = null;
  dataPrevisaoEntrega = null;
  tipoCompraGovernamental = null;
  percentualReducaoIbs = null;
  tipoOperacaoGovernamental = null;
  finalidadeNfe = null;
  tipoFinalidadeFiscal = null;
  clienteTipoContribuinteId = null;
  codigoMunicipioConsumo = null;
  presencaConsumidor = null;
  nfSaidaReferencias = [];

  constructor(nfSaida, id = null) {
    if (id) {
      this.id = id;
      this.createdAt = nfSaida.createdAt;
      this.updatedAt = nfSaida.updatedAt;
      this.insertUserId = nfSaida.insertUserId;
      this.status = nfSaida.status;
      this.orcamentoImport = nfSaida.orcamentoImport;
      this.pedidoImport = nfSaida.pedidoImport;
      this.ordemServicoImport = nfSaida.ordemServicoImport;
      this.importacaoDocumento = nfSaida.importacaoDocumento;
      this.pedidoIds = nfSaida.pedidoIds;
      this.orcamentoIds = nfSaida.orcamentoIds;
      this.ordemServicoIds = nfSaida.ordemServicoIds;
      this.condicionalIds = nfSaida.condicionalIds;
      this.serieDocumento = nfSaida.serieDocumento;
      this.numeroDocumento = nfSaida.numeroDocumento;
      this.numeroProtoc = nfSaida?.numeroProtoc;
      this.dataEmissao = nfSaida.dataEmissao || formatDate.toSend(new Date());
      this.dataSaida = nfSaida.dataSaida || formatDate.toSend(new Date());
      this.operacaoFiscalId = nfSaida.operacaoFiscalId;
      this.grupoTributarios = nfSaida.grupoTributarios;
      this.modeloDocumento = nfSaida.modeloDocumento;
      this.notasCredito = nfSaida.notasCredito;
      this.operacaoFiscal = nfSaida.operacaoFiscal;
      this.chaveAcesso = nfSaida.chaveAcesso;
      this.quantidadeParcelas = nfSaida.quantidadeParcelas;
      this.chaveAcessoReferencia = nfSaida.chaveAcessoReferencia;
      this.clienteId = nfSaida.clienteId;
      this.clienteEmail = nfSaida.clienteEmail;
      this.clienteNome = nfSaida.clienteNome;
      this.clienteCnpjCpf = nfSaida?.clienteCnpjCpf || null;
      this.clienteTipoContribuinteId =
        nfSaida?.clienteTipoContribuinteId || null;
      this.clienteInscricaoEstadual = nfSaida?.clienteInscricaoEstadual || null;
      this.clienteInscricaoSuframa = nfSaida?.clienteInscricaoSuframa || null;
      this.vendedorId = nfSaida.vendedorId;
      this.vendedorBancoCaixaId = nfSaida.vendedorBancoCaixaId;
      this.prestadorServicoId = nfSaida.prestadorServicoId;
      this.modalidadeFrete = nfSaida.modalidadeFrete || "mfSemFrete";
      this.transportadoraId = nfSaida.transportadoraId;
      this.transportadoraNome = nfSaida.transportadoraNome;
      this.transportadoraCnpjCpf = nfSaida.transportadoraCnpjCpf;
      this.transportadoraIe = nfSaida.transportadoraIe;
      this.transportadoraEnderecoRua = nfSaida.transportadoraEnderecoRua;
      this.transportadoraEnderecoMunicipio =
        nfSaida.transportadoraEnderecoMunicipio;
      this.transportadoraEnderecoUf = nfSaida.transportadoraEnderecoUf;
      if (nfSaida.pesoBruto > 0 && nfSaida.pesoLiquido > 0) {
        this.qtdVolumes = nfSaida.qtdVolumes;
        this.pesoBruto = nfSaida.pesoBruto;
        this.pesoLiquido = nfSaida.pesoLiquido;
        this.produtoMarca = nfSaida.produtoMarca;
        this.produtoNumero = nfSaida.produtoNumero;
        this.especieVolume = nfSaida.especieVolume;
      }
      this.freteCompoeNota = nfSaida.freteCompoeNota || true;
      this.desconto = nfSaida.desconto;
      this.descontoPorcentagem = nfSaida.descontoPorcentagem;
      this.acrescimo = nfSaida.acrescimo;
      this.despesas = nfSaida.despesas;
      this.totalMercadoria = nfSaida.totalMercadoria;
      this.totalPagamentos =
        nfSaida.totalPagamentos || totalPagamentos(this.nfSaidaPagamentos);
      this.totalVenda = nfSaida.totalVenda;
      this.informacoesAdicionais = nfSaida.informacoesAdicionais;
      this.informacoesFisco = nfSaida.informacoesFisco;
      this.intermediadorRazaoSocial = nfSaida.intermediadorRazaoSocial;
      this.intermediadorCnpj = nfSaida.intermediadorCnpj;
      this.nfSaidaEnderecoCliente = nfSaida.nfSaidaEnderecoCliente
        ? new NfSaidaEnderecoCliente(nfSaida.nfSaidaEnderecoCliente)
        : null;
      this.documentoDevolucaoCliente = nfSaida.documentoDevolucaoCliente;
      this.documentoDevolucaoFornecedor = nfSaida.documentoDevolucaoFornecedor;
      this.frete = nfSaida.frete;
      this.nfSaidaItens = nfSaida.nfSaidaItens;
      this.nfSaidaPagamentos = nfSaida.nfSaidaPagamentos?.length
        ? nfSaida.nfSaidaPagamentos.map(
            (pagamento) => new NfSaidaPagamento(pagamento),
          )
        : [];
      this.devolucoesClienteIds = nfSaida?.devolucoesClienteIds || null;
      this.devolucoesFornecedorIds = nfSaida?.devolucoesFornecedorIds || null;
      this.nfSaidaImportadaId = nfSaida.nfSaidaImportadaId;
      this.vendedorObrigatorio = nfSaida.vendedorObrigatorio;
      this.enderecoEntregaId = nfSaida.enderecoEntregaId;
      this.meioPagamentoId = nfSaida.meioPagamentoId;
      this.condicaoPagamentoId = nfSaida.condicaoPagamentoId;
      this.nfSaidaCartasCorrecao = this.formatarCartasCorrecao(
        nfSaida.nfSaidaCartasCorrecao,
      );
      this.descontoItem = nfSaida.descontoItem || false;
      this.freteItem = nfSaida.freteItem || false;
      this.despesasItem = nfSaida.despesasItem || false;
      this.empresaDestinoId = nfSaida?.empresaDestinoId ?? null;
      this.dataPrevisaoEntrega = nfSaida?.dataPrevisaoEntrega ?? null;
      this.finalidadeNfe = nfSaida?.finalidadeNfe ?? null;
      this.tipoFinalidadeFiscal = nfSaida?.tipoFinalidadeFiscal ?? null;
      this.codigoMunicipioConsumo = nfSaida?.codigoMunicipioConsumo ?? null;
      this.presencaConsumidor = nfSaida.presencaConsumidor;
      this.nfSaidaReferencias = nfSaida.nfSaidaReferencias?.length
        ? nfSaida.nfSaidaReferencias.map((referencia) => ({
            id: referencia.id,
            nfSaidaReferenciaId: referencia.nfSaidaReferenciaId,
            chaveDocumentoReferencia: referencia.chaveDocumentoReferencia,
            tipoDocumentoReferencia: referencia.tipoDocumento,
          }))
        : [];
    }
    this.dataEmissao = nfSaida?.dataEmissao || formatDate.toSend(new Date());
    this.dataSaida = nfSaida?.dataSaida || formatDate.toSend(new Date());
    this.modalidadeFrete = nfSaida?.modalidadeFrete || "mfSemFrete";
    this.freteCompoeNota = nfSaida?.freteCompoeNota || false;
    this.operacaoEntrada = nfSaida?.operacaoEntrada;
    this.subtotalTributosIncidentes = nfSaida?.subtotalTributosIncidentes;
  }

  formatarCartasCorrecao(nfSaidaCartasCorrecao = []) {
    const size = nfSaidaCartasCorrecao.length;
    const ordenadosDesc = nfSaidaCartasCorrecao.sort((a, b) => b.id - a.id);
    return ordenadosDesc.map((item, index) => ({
      ...item,
      numeroSequencial: size - index,
    }));
  }

  setMedidas(name, value) {
    this[name] = unformatPrice(value);
  }

  setNfSaidaReferencias(documentosReferenciados = []) {
    this.nfSaidaReferencias = documentosReferenciados.map((referencia) => ({
      id: referencia.id,
      nfSaidaReferenciaId: referencia.nfSaidaReferenciaId,
      chaveDocumentoReferencia: referencia.chaveDocumentoReferencia,
      tipoDocumento: referencia.tipoDocumentoReferencia,
    }));
  }

  setChangeItens(id, itens, nfSaida = this) {
    this.desconto = calculaSubtotalParaChave(itens, "", "desconto");
    this.frete = calculaSubtotalParaChave(itens, "", "frete");
    this.despesas = calculaSubtotalParaChave(itens, "", "despesas");
    this.nfSaidaItens = itens?.length
      ? itens.map(
          (item, index) => new NfSaidaItem(item, index, this.operacaoFiscal),
        )
      : [];

    this.baseIcmsTotal = nfSaidaTotalTributos.totalBaseIcms(id, itens, nfSaida);
    this.valorIcmsTotal = nfSaidaTotalTributos.totalValorIcms(
      id,
      itens,
      nfSaida,
    );
    this.baseIcmsSt = nfSaidaTotalTributos.totalBaseIcmsSt(id, itens, nfSaida);
    this.valorIcmsSt = nfSaidaTotalTributos.totalValorIcmsSt(
      id,
      itens,
      nfSaida,
    );
    this.valorIpiTotal = nfSaidaTotalTributos.totalValorIpi(
      id,
      itens,
      nfSaida.documentoDevolucaoFornecedor,
    );
    this.valorIbsUf = nfSaidaTotalTributos.totalValorIbsUf(id, itens);
    this.valorIbsMun = nfSaidaTotalTributos.totalValorIbsMun(id, itens);
    this.valorCbsTotal = nfSaidaTotalTributos.totalValorCbs(id, itens);

    this.totalMercadoria = totalItensLista(itens);
    this.totalVenda = totalVenda(nfSaida, itens);
    this.descontoPorcentagem = calculoDesconto(itens, nfSaida, false);
    this.grupoTributarios = [
      ...new Set(this.nfSaidaItens.map((item) => item.grupoTributacaoId)),
    ];
  }

  setChangePagamentos(pagamentos) {
    this.nfSaidaPagamentos = pagamentos?.length
      ? pagamentos.map((pagamento) => new NfSaidaPagamento(pagamento))
      : [];
    this.totalPagamentos = totalPagamentos(pagamentos);
  }

  setIdentificarCliente(value) {
    this.clienteId = value?.id;
    this.clienteEmail = value?.email;
    this.clienteCnpjCpf = value?.cnpjCpf;
    this.clienteNome = value?.nomeRazaoSocial;
    this.clienteInscricaoEstadual =
      value?.inscricaoEstadual || value?.inscricaoEstadualRural;
    this.clienteTelefone = value?.telefone;
    this.clienteCelular = value?.celular;
    this.clienteInscricaoSuframa = value?.inscricaoSuframa;
    this.tipoCompraGovernamental = value?.clientes?.[0].tipoCompraGovernamental;
    this.percentualReducaoIbs = value?.clientes?.[0].percentualReducaoIbs;
    this.tipoOperacaoGovernamental =
      value?.clientes?.[0].tipoOperacaoGovernamental;
    this.clienteTipoContribuinteId = value?.clientes?.[0]?.tipoContribuinteId;
  }

  setInscricaoEstadual(value) {
    this.clienteInscricaoEstadual = value;
  }

  setCodigoMunicipioConsumo(value) {
    this.codigoMunicipioConsumo = value ?? null;
  }

  setIdentificarIntermediador(value) {
    this.intermediadorRazaoSocial = value.nomeRazaoSocial;
    this.intermediadorCnpj = value.cnpjCpf;
  }

  setVendedorObrigatorioPermissao(permissao) {
    this.vendedorObrigatorio = permissao;
  }

  setTotalVenda(nfSaida = this, itens = this.nfSaidaItens) {
    this.totalVenda = totalVenda(nfSaida, itens);
  }

  setEnderecoCliente(enderecoAlterado, enderecoCliente) {
    const endereco = enderecoAlterado || enderecoCliente;
    if (endereco) {
      if (this.clienteId) {
        endereco.pessoaId = this.clienteId;
      }
      this.nfSaidaEnderecoCliente = endereco;
    } else {
      this.nfSaidaEnderecoCliente = null;
    }
  }

  setEnderecoClienteEmpresa(empresa) {
    const enderecoEmpresaDestino = new NfSaidaEnderecoCliente();
    enderecoEmpresaDestino.setEnderecoEmpresaDestino(empresa);
    this.nfSaidaEnderecoCliente = enderecoEmpresaDestino;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeDate(name, date) {
    this[name] = date != "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value, listaEstados) {
    this[name] = value ? value.id : null;
    if (name === "clienteId") {
      this.setIdentificarCliente(value);
    }
    if (name === "transportadoraId") {
      this.transportadoraNome = value?.nomeRazaoSocial;
      this.transportadoraCnpjCpf = value?.cnpjCpf;
      this.transportadoraIe = value?.inscricaoEstadual;
      this.transportadoraEnderecoRua = value?.enderecos[0]?.logradouro;
      this.transportadoraEnderecoMunicipio = value?.enderecos[0]?.cidade?.nome;
      this.transportadoraEnderecoUf = value?.enderecos[0]?.cidade?.estado.sigla;
      if (listaEstados?.length) {
        this.transportadoraExportacaoUf = valueHelper.autoComplete(
          listaEstados || [],
          value?.transportadoras[0]?.ufEmbarque,
        )?.sigla;
      }
      this.transportadoraExportacaoLocalEmbarque =
        value?.transportadoras[0]?.localEmbarque;
      this.transportadoraExportacaoLocalDesembarque =
        value?.transportadoras[0]?.localDesembarque;
    }
  }

  setOperacaoFiscal(operacaoFiscal = {}) {
    this.operacaoFiscal = new OperacaoFiscal(operacaoFiscal);
    this.operacaoFiscalId = operacaoFiscal.id;
    const isSerieOffline =
      operacaoFiscal.pdvOffline?.length &&
      operacaoFiscal.pdvOffline?.some(
        (item) => item.serie === this.serieDocumento,
      );
    this.serieDocumento = isSerieOffline
      ? this.serieDocumento
      : operacaoFiscal?.serieDocumento;
    this.modeloDocumento = operacaoFiscal?.modeloDocumento;
    this.informacoesOperacaoFiscal = operacaoFiscal?.informacaoComplementar;
    this.presencaConsumidor = operacaoFiscal?.presencaConsumidor;
    if (!this.id && dataEmissaoBloqueada(operacaoFiscal)) {
      this.dataEmissao = formatDate.toSend(new Date());
      if (isBefore(new Date(this.dataSaida), new Date(this.dataEmissao))) {
        this.dataSaida = this.dataEmissao;
      }
    }
  }

  setColaboradorVendedorUsuario(
    vendedorId,
    vendedorBancoCaixaId,
    permissaoUtilizarCaixa,
  ) {
    this.vendedorId = vendedorId;
    if (permissaoUtilizarCaixa) {
      this.vendedorBancoCaixaId = vendedorBancoCaixaId;
    }
  }

  setNotasCredito(notasCredito) {
    this.notasCredito = notasCredito;
  }

  setCartasCorrecao(nfSaidaCartasCorrecao) {
    this.nfSaidaCartasCorrecao = nfSaidaCartasCorrecao;
  }

  setVendedorBancoCaixaId(bancoCaixaId) {
    this.vendedorBancoCaixaId = bancoCaixaId;
  }

  setConfiguracoes(configuracoes) {
    this.descontoItem = configuracoes?.descontoVendaItem;
    this.despesasItem = configuracoes?.despesaVendaItem;
    this.freteItem = configuracoes?.freteVendaItem;
    this.obrigatoriedadeMeioPagamento =
      configuracoes?.obrigatoriedadeMeioPagamento;
  }
}
